import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConstants } from '../../../../app/shared/constants/api-constants';
import { DashboardSummaryWithTrainingData } from '../models/user-home-dashboardSummary';
import { UserHomeCardsAccess } from '../models/userHomeCardsAccess';

@Injectable({
  providedIn: 'root'
})
export class UserHomeService {

  constructor(private httpClient: HttpClient) { }

  getDocumentDashboardCounts(access: UserHomeCardsAccess): Observable<DashboardSummaryWithTrainingData> {
    const { myFavoritesAccess, myAssignedAdminAccess, myDocCollabsAccess, myDocFormattingsAccess,
            myQAReviewsAccess, myDocReviewsAccess, myDocApprovalsAccess, myChangeRequestsAccess,
            myPeriodicReviewsAccess, myHardcopyActivitiesAccess, myClientSignaturesAccess,
            myQuarantinedDocumentsAccess } = access;
    return this.httpClient.post<DashboardSummaryWithTrainingData>(
      ApiConstants.Dashboard_GetUserHomeDocumentCounts_Api,
      { myFavoritesAccess, myAssignedAdminAccess, myDocCollabsAccess, myDocFormattingsAccess,
        myQAReviewsAccess, myDocReviewsAccess, myDocApprovalsAccess, myChangeRequestsAccess,
        myPeriodicReviewsAccess, myHardcopyActivitiesAccess, myClientSignaturesAccess,
        myQuarantinedDocumentsAccess }
    );
  }

  getTrainingDashboardCounts(access: UserHomeCardsAccess): Observable<DashboardSummaryWithTrainingData> {
    const { myPendingTrainingsAccess, myPendingTrainingPlanReviewsAccess } = access;
    return this.httpClient.post<DashboardSummaryWithTrainingData>(
      ApiConstants.Dashboard_GetUserHomeTrainingCounts_Api,
      { myPendingTrainingsAccess, myPendingTrainingPlanReviewsAccess }
    );
  }

  getDelegateDashboardCounts(access: UserHomeCardsAccess): Observable<DashboardSummaryWithTrainingData> {
    const { myDelegationsAccess, delegatedToMeAccess } = access;
    return this.httpClient.post<DashboardSummaryWithTrainingData>(
      ApiConstants.Dashboard_GetUserHomeDelegateCounts_Api,
      { myDelegationsAccess, delegatedToMeAccess }
    );
  }

  getSkillDashboardCounts(): Observable<DashboardSummaryWithTrainingData> {
    return this.httpClient.get<DashboardSummaryWithTrainingData>(ApiConstants.Dashboard_GetUserHomeSkillCounts_Api);
  }

  getVerificationSkillDashboardCounts(): Observable<DashboardSummaryWithTrainingData> {
    return this.httpClient.get<DashboardSummaryWithTrainingData>(ApiConstants.Dashboard_GetUserHomeVerificationSkillCounts_Api);
  }

  getUserHomeAuthentication(): Observable<UserHomeCardsAccess> {
    return this.httpClient.get<UserHomeCardsAccess>(ApiConstants.UserHomeAuthorization_Api);
  }
}

